import { render, staticRenderFns } from "./BoxRank.vue?vue&type=template&id=1ed3b4aa&scoped=true"
import script from "./BoxRank.vue?vue&type=script&lang=js"
export * from "./BoxRank.vue?vue&type=script&lang=js"
import style0 from "./BoxRank.vue?vue&type=style&index=0&id=1ed3b4aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed3b4aa",
  null
  
)

export default component.exports